/* eslint-disable react/prop-types */
import React, { Fragment } from "react"
import { Col, Spinner } from "reactstrap"
import { useTranslation } from "react-i18next"
const LabelChargeData = props => {
  const { t } = useTranslation()

  const {
    showloading = false,
    label =t("global:lblLoading"),
    title = "",
  } = props
  return (
    <Fragment>
      <Col
        md={12}
        className="text-left small text-primary ml-2"
        style={{
          display: showloading ? "" : "none",
        }}
      >
        {title} {label} <Spinner className="ms-2" color="primary" size="sm" />
      </Col>
    </Fragment>
  )
}
export default LabelChargeData
